{
    "name": "Pointed Cabbage",
    "binomial_name": "Brassica oleracea var. capitata",
    "common_names": [
        "Pointed cabbage",
        "hearted cabbage",
        "sweetheart cabbage",
        "hispi cabbage"
    ],
    "description": "Pointed, Sweetheart, Hearted, or Hispi Cabbage, is a type of green cabbage with a pointed head. It's leaves have a softer texture and sweeter taste and are more open than typical green cabbage. It can be added to stir-fries and casseroles or boiled or saut\u00e9ed.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors or outdoors",
    "spread": 30,
    "row_spacing": 30,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [
        "rosemary",
        "thyme"
    ],
    "image": "/crops/images/pointed-cabbage.jpg",
    "icon": "/crops/icons/pointed-cabbage.avif"
}